module.exports = __webpack_public_path__ + "img/back.75034b96.svg";